/* app/onboarding/module1/LearnHubButton.jsx — «шляпа студента»: хаб обучения
   в шапке (рядом с колоколом уведомлений; рендерится из PageHeader и ChatHeader).
   Меню (идиома TrainingMenu из AnalyticsTour):
   - «Продолжить настройку» — только пока флоу демо-CJM не завершён:
     window-событие 'onb1:open' снимает session-dismiss и открывает Module1Overlay;
   - «Онбординг по ассистенту» — всегда: /chat + старт квеста (Модуль 2);
   - «Тур по аналитике» — /analytics?training=tour (ручной запуск тура обрабатывает
     экран Аналитики, контракт W3-F3). Только если у активного пространства открыты и
     «Аналитика», и «Интеграции» (posAnalyticsAvailable): тур идёт по отчётам кассы, а при
     закрытом тарифом разделе пункт вёл бы на редирект или в тост «сначала подключите кассу».
   Вне AuthProvider/OnboardingProvider (напр. витрина /dev/uikit) — рендерит null. */

import React from 'react';
import { useAuth } from '../../providers/AuthProvider.jsx';
import { useOnboarding } from '../OnboardingProvider.jsx';
import { Icon } from '../../../components/ui/Icon.jsx';
import { Popover, PopoverItem } from '../../../components/ui/Popover.jsx';
import { posAnalyticsAvailable } from '../../../lib/planSections.js';
import { RR } from '../../../lib/router.jsx';

  const { useNavigate } = RR;

  function LearnHubButton() {
    const auth = useAuth ? useAuth() : null;
    const onb = useOnboarding ? useOnboarding() : null;
    const navigate = useNavigate();
    const user = auth && auth.user;
    if (!user) return null;

    const tourAvailable = posAnalyticsAvailable(auth && auth.activeWorkspace);
    const flow = user.onboarding_flow;
    const showResume = !!(flow && !flow.completed);

    const openModule1 = () => {
      try { window.dispatchEvent(new CustomEvent('onb1:open')); } catch { /* noop */ }
    };
    const startQuest = () => {
      navigate('/chat');
      if (onb && onb.start) onb.start(0);
    };

    return (
      <Popover placement="bottom-end" width={264} trigger={(
        <button type="button" className="learnhub-trigger" aria-label="Обучение">
          <Icon name="graduation-cap" size={18} />
        </button>
      )}>
        {({ close }) => (
          <>
            {showResume && (
              <PopoverItem icon="settings" close={close} onClick={openModule1}>
                Продолжить настройку
              </PopoverItem>
            )}
            <PopoverItem icon="sparkles" close={close} onClick={startQuest}>
              Онбординг по ассистенту
            </PopoverItem>
            {tourAvailable && (
              <PopoverItem icon="analytics" close={close} onClick={() => navigate('/analytics?training=tour')}>
                Тур по аналитике
              </PopoverItem>
            )}
          </>
        )}
      </Popover>
    );
  }

export { LearnHubButton };
